import Vue from 'vue'
import Vuex from 'vuex'
import Config from './Config'
import axios from 'axios'
import moment from 'moment'
import { loadProgressBar } from 'axios-progress-bar'
import MobileDetect from 'mobile-detect'

loadProgressBar({ showSpinner: false })

Vue.use(Vuex);

const mb = new MobileDetect(window.navigator.userAgent);

//for old ios devices (ios <= 9.3.*) with session&localStorage bug
const isKiosk = () => {
    try{
        return sessionStorage.getItem('isKiosk') == 'true' ? true : false;
    } catch (e){
        console.log('failed to access sessionStorage');
        return false;
    }
};

const getLang = () => {
    try{
        return localStorage.getItem('lang');
    } catch (e){
        console.log('failed to access sessionStorage');
        return 'he';
    }
};

const getMenuState = () => {
    try{
        return localStorage.getItem('menuState')
    } catch (e){
        console.log('failed to access sessionStorage');
        return 'closed';
    }
};

// root state object.
// each Vuex instance is just a single state tree.
const state = {
    lastInteraction:(Math.floor(Date.now() / 1000)),
    isLogged:false,
    dashboardInitiated:false,
    userName:'',
    user:{menus:[]},
    users:[],
    event:{type:{},gallery:{}},
    events:[],
    kioskEvent:{guests:[],preset:{}},
    halls:[],
    presets:[],
    printAssets:{
        logo:'',
        divider:'',
    },
    guestGroups:[],
    closestEvents:[],
    isKiosk:(location.href.includes('?kiosk') || isKiosk()),
    /*isKiosk:(window.screen.height > window.screen.width),*/
    equipments:[],
    usedBanners:[],
    tables:[],
    eventTypes:[],
    dashboard:null,
    snippetsInitialized:false,
    selectedEventID:0,
    app:{name:'SeatUP',banners:[]},
    preferences:{
        lang:( getLang() ? getLang() : 'he' ),
        menuState:( getMenuState() == 'closed' ? 'closed' : 'open' ),
    },
    axiosQueue:[],
    isTablet: ((mb.phone() !== null && mb.phone() !== "") || (mb.tablet() !== null && mb.tablet() !== "") ? true : false)
}

const stateDef = state;

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {

}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {

    addSnippets:()=>{
        try {

            if (!state.snippetsInitialized && state.hasOwnProperty('app') && state.app.hasOwnProperty('extra') && state.app.extra
                !== null && state.app.extra.hasOwnProperty('snippets')) {
                const snippets = JSON.parse(state.app.extra.snippets);
                if(typeof snippets === "string" && snippets !== ""){
                    $('head').append(snippets)
                    state.snippetsInitialized = true;
                }
            }
        } catch (e){
            console.log(`failed to parse snippets - ${e.message}`);
        }
    },

    makeLogin: ({comnit},o) =>
        new Promise((resolve, reject) => {
            var $this = this;
            o.method = 'login';
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.login, o,Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    try {
                        if (response.data.status) {
                            state.user = response.data.data;
                            state.isLogged = true
                            resolve();
                        } else {
                            state.isLogged = false
                            reject()
                        }
                    } catch (e) {
                        reject()
                        console.warn('failed to process login - ' + e.toString())
                    }
                })
                .catch(function (e) {
                    reject()
                    console.warn('login failed - ' + e.toString());
                });

        }),

    checkPassword: ({comnit},password) =>
        new Promise((resolve, reject) => {
            var $this = this;
            var o = {password:password};
            o.method = 'checkPassword';
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.login, o,Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    try {
                        if (response.data.status) {
                            resolve();
                        } else {
                            reject()
                        }
                    } catch (e) {
                        reject()
                        console.warn('failed to process password check - ' + e.toString())
                    }
                })
                .catch(function (e) {
                    reject()
                    console.warn('password check failed - ' + e.toString());
                });

        }),

    getDashboardData: ()=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.dashboard, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if((response.data.code == -5 || response.data.code == -9) && !response.data.status){
                        //login
                        state.isLogged = false
                        reject();
                    }else{
                        response = response.data;
                        state.dashboard = response.data.app;
                        state.user = response.data.user;
                        state.users = (response.data.users ? response.data.users : []);
                        state.userName = state.user.name;
                        state.halls = (response.data.halls ? response.data.halls : []);
                        state.eventTypes = (response.data.eventTypes ? response.data.eventTypes : []);
                        state.presets = (response.data.presets ? response.data.presets : []);
                        state.isLogged = true;
                        state.dashboardInitiated = true;

                        if(state.user.type == 3){
                            state.event = response.data.event;
                        }

                        if(typeof response.data.app !=='undefined'){
                            state.app = response.data.app
                            document.title = state.app.name;

                            if(!state.snippetsInitialized) store.dispatch('addSnippets')

                        }else{
                            state.app = {
                                name:'SeatUP'
                            }
                        }

                        resolve();
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    checkLogin: ()=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.isLogged,{method:'isLogged'}, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        state.isLogged = true;
                        resolve(response.data)
                    }else{
                        state.isLogged = false;
                        reject()
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getUsers: ()=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.users, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        state.users = response.data.data;
                        resolve()
                    }else{
                        state.users = [];
                        reject()
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getBanners: ()=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.banners, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        state.app.banners = (response.data.data ? response.data.data : []);
                        resolve()
                    }else{
                        state.app.banners = [];
                        reject()
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getPresets: ()=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.presets, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        state.presets = (response.data.data ? response.data.data : []);
                        resolve()
                    }else{
                        state.presets = [];
                        reject()
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getHalls: ()=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.halls, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        state.halls = (response.data.data ? response.data.data : []);
                        resolve()
                    }else{
                        state.halls = [];
                        reject()
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getCalendar: ()=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.calendar, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    response = response.data;
                    if(response.status){
                        resolve(response.data)
                    }else{
                        reject(response)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getTables: ()=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.tables, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        state.tables = response.data.data;
                        resolve()
                    }else{
                        state.halls = [];
                        reject()
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getEquipments: ()=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.equipments, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        state.equipments = response.data.data;
                        resolve()
                    }else{
                        state.halls = [];
                        reject()
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getEvents: ({comnit},homepage = false)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.get(`${Config.SETTINGS.API_URL}${Config.API_ROUTES.events}${homepage ? '?homepage=true' : ''}`, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        if(state.user.type == 3){
                            state.event = response.data.data;
                        }else {
                            state.events = response.data.data;

                            if(state.events.length>0){
                                state.closestEvents = [];
                                for(var event of state.events){
                                    if(event.date+86400 >= moment().unix() && state.closestEvents.length < 20) state.closestEvents.push(event)
                                }
                            }

                        }
                        resolve()
                    }else{
                        if(state.user.type == 3){
                            state.event = {};
                        }else {
                            state.events = [];
                        }
                        reject()
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getUser: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;

            for(var user of state.users) {
                if (user.id == id){
                    resolve({data:user});
                    return;
                }
            }

            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.users + '/' + id, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getBanner: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.banners + '/' + id, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getPreset: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.presets + '/' + id, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getEquipment: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.equipments + '/' + id, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getHall: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;

            for(var hall of state.halls) {
                if (hall.id == id) resolve(hall);
            }

            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.halls + '/' + id, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getTable: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;

            for(var table of state.tables) {
                if (table.id == id){
                    resolve(table);
                    return;
                }
            }

            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.tables + '/' + id, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    uploadFile: ({comnit},formData)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.upload,formData, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    addBanner: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.banners,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getBanners');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    addPreset: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.presets,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getPresets');
                        store.dispatch('getHalls');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    addTable: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.tables,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getTables');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    addEquipment: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.equipments,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getEquipments');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    addHall: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.halls,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getHalls');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    updateBanner: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.banners + '/' + data.id,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getBanners');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),


    updatePreset: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.presets + '/' + data.id,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getPresets');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),


    changeCalendarEventDate: ({comnit},event)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.calendar + '/' + event.id,event, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    updateHall: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.halls + '/' + data.id,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getHalls');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    updateTable: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.tables + '/' + data.id,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getTables');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    updateEquipment: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.equipments + '/' + data.id,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getEquipments');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    updateGuest: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.guests + '/event/' + data.event + '/' + data.id,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    updateAppSettings: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.settings,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getDashboardData');
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getEvent: ({comnit},id)=>
        new Promise((resolve, reject) => {
            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.events + '/' + id, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        state.guestGroups = response.data.data.guestGroups;
                        resolve(response.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getEventWithGuests: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.events + '/' + id + '?getGuestsForTables=true', Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        state.guestGroups = response.data.data.event.guestGroups;
                        resolve(response.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getMeeting: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.appointments + '/' + id, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getQuotation: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.quotations + '/' + id, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    getGuests: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.get(Config.SETTINGS.API_URL + Config.API_ROUTES.guests + '/event/' + id, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    logoff: ()=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.login,{method:'logoff'}, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        location.reload();
                    }else{
                        state.isLogged = false;
                        reject()
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    checkResetToken: ({comnit},token) =>
        new Promise((resolve, reject) => {
            var $this = this;
            var o = {method:'checkToken',token:token};
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.login, o,Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    try {
                        if (response.data.status) {
                            resolve(true);
                        } else {
                            resolve()
                        }
                    } catch (e) {
                        reject()
                        console.warn('failed to process token check - ' + e.toString())
                    }
                })
                .catch(function (e) {
                    reject()
                    console.warn('token check failed - ' + e.toString());
                });

        }),

    createReport: ({comnit},report) =>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.reports, report,Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    try {
                        if (response.data.status) {
                            resolve(response.data.data);
                        } else {
                            reject()
                        }
                    } catch (e) {
                        reject()
                        console.warn('failed to process report - ' + e.toString())
                    }
                })
                .catch(function (e) {
                    reject()
                    console.warn('report failed - ' + e.toString());
                });

        }),

    resetPassword: ({comnit},o)=>
        new Promise((resolve, reject) => {
            var $this = this;
            o.method = 'resetPassword';
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.login,o, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        state.isLogged = false;
                        resolve(response.data)
                    }else{
                        state.isLogged = false;
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    updateUser: ({comnit},o)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.users + '/' + o.id,o, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){

                        var data = response.data.data;
                        //update dashboard data
                        actions.getDashboardData().then(response => {
                            //on success
                            resolve(data)
                        });
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    updateEvent: ({comnit},o)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.events + '/' + o.id,o, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){

                        const data = response.data.data;
                        //update dashboard data
                        actions.getDashboardData().then(response => {
                            //on success
                            resolve(data)
                        });
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    updateMeeting: ({comnit},o)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.appointments + '/' + o.id,o, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){

                        var data = response.data.data;
                        resolve(data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    updateQuotation: ({comnit},o)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.quotations + '/' + o.id,o, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){

                        var data = response.data.data;
                        resolve(data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    kioskImageUpload: ({comnit},o)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.post(Config.SETTINGS.API_URL + Config.API_ROUTES.events + '/gallery/' + o.id,o, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){

                        var data = response.data.data;
                        //update dashboard data
                        actions.getDashboardData().then(response => {
                            //on success
                            resolve(data)
                        });
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    addUser: ({comnit},o)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.users ,o, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){

                        var data = response.data.data;
                        //update dashboard data
                        actions.getDashboardData().then(response => {
                            //on success
                            resolve(data)
                        });
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    addGuest: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;
            data.event = data.eventID
            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.guests  + '/event/' + data.eventID ,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status) {
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject(response.data)
                });

        }),

    importGuests: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.guests  + '/event/' + data.eventID + '/import' ,data, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status) {
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject(response.data)
                });

        }),

    resetGuests: ({comnit},eventID)=>
        new Promise((resolve, reject) => {
            var $this = this;

            axios.delete(Config.SETTINGS.API_URL + Config.API_ROUTES.guests  + '/event/' + eventID + '/reset' , Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status) {
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject(error)
                });

        }),

    addMeeting: ({comnit},o)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.appointments ,o, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data);
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    addQuotation: ({comnit},o)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.quotations ,o, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        resolve(response.data);
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    addEvent: ({comnit},o)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.put(Config.SETTINGS.API_URL + Config.API_ROUTES.events ,o, Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){

                        var data = response.data;
                        //update dashboard data
                        actions.getDashboardData().then(response => {
                            //on success
                            resolve(data)
                        });
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    deleteUser: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.delete(Config.SETTINGS.API_URL + Config.API_ROUTES.users + '/' + id , Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){

                        var data = response.data.data;
                        //update dashboard data
                        actions.getDashboardData().then(response => {
                            //on success
                            resolve(data)
                        });
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    deleteGuest: ({comnit},data)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.delete(Config.SETTINGS.API_URL + Config.API_ROUTES.guests + '/event/' + data.event + '/' + data.id , Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status) {
                        resolve(response.data.data)
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    deleteEvent: ({comnit},eventID)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.delete(Config.SETTINGS.API_URL + Config.API_ROUTES.events + "/" +
                eventID , Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status) {
                        resolve(response.data.data)
                        store.dispatch('getEvents');
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    deleteBanner: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.delete(Config.SETTINGS.API_URL + Config.API_ROUTES.banners + '/' + id , Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getBanners')
                        resolve(response.data);
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    deletePreset: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.delete(Config.SETTINGS.API_URL + Config.API_ROUTES.presets + '/' + id , Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getPresets')
                        resolve(response.data);
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    deleteHall: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.delete(Config.SETTINGS.API_URL + Config.API_ROUTES.halls + '/' + id , Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getHalls')
                            .then(res =>{
                                //success
                                resolve(response.data);
                            })
                            .catch(err => {
                                //err
                                resolve(response.data);
                            })
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    deleteTable: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.delete(Config.SETTINGS.API_URL + Config.API_ROUTES.tables + '/' + id , Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getTables')
                            .then(res =>{
                                //success
                                resolve(response.data);
                            })
                            .catch(err => {
                                //err
                                resolve(response.data);
                            })
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    deleteEquipment: ({comnit},id)=>
        new Promise((resolve, reject) => {
            var $this = this;
            axios.delete(Config.SETTINGS.API_URL + Config.API_ROUTES.equipments + '/' + id , Config.DEFAULT_API_SETTINGS)
                .then(function (response) {
                    if(response.data.status){
                        store.dispatch('getEquipments')
                            .then(res =>{
                                //success
                                resolve(response.data);
                            })
                            .catch(err => {
                                //err
                                resolve(response.data);
                            })
                    }else{
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                    reject()
                });

        }),

    saveLang: ({comnit},lang) =>{
        try{
            localStorage.setItem('lang',lang);
        } catch (e){
            console.log('failed to access localStorage')
        }
        state.preferences.lang = lang;
    },

    saveMenuState: ({comnit},_) =>{
        try{
            localStorage.setItem('menuState',_);
        } catch (e){
            console.log('failed to access localStorage')
        }
        state.preferences.menuState = _;
    }
}

// getters are functions
const getters = {
    isLogged () {
        return state.isLogged;
    },
    getUser (){
        return state.user;
    }
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
const store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations
});

export default store;
